import { Autocomplete, FormLabel, Grid, TextField } from "@mui/material";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { Formik } from "formik";
import { useCallback, useMemo, useState } from "react";
import { RewardStudent } from "../../../types/slices/rewardStudentType";
import { useRewardStudentStore } from "../../../hooks/useRewardStudentStore";

const concepts = [
  { name: "S/. 5.00 (500 puntos)", value: "500", withDetail: true },
  { name: "S/. 10.00 (800 puntos)", value: "800", withDetail: true },
  { name: "S/. 15.00 (1000 puntos)", value: "1000", withDetail: true },
  { name: "S/. 20.00 (1200 puntos)", value: "1200", withDetail: true },
  {
    name: "01 Constancia Digital (440 puntos)",
    value: "440",
    withDetail: false,
  },
  {
    name: "01 Certificado Digital (680 puntos)",
    value: "680",
    withDetail: false,
  },
  {
    name: "01 Certificado Físico + Digital (780 puntos)",
    value: "780",
    withDetail: false,
  },
  {
    name: "01 Certificado Físico + Digital + Constancia Digital (950 puntos)",
    value: "950",
    withDetail: false,
  },
  {
    name: "01 Certificado Físico + Digital + Constancia Física  (1150 punntos)",
    value: "1150",
    withDetail: false,
  },
];

const conceptDetails = [
  { name: "Dcto. Certificacion", value: "Dcto. Certificacion" },
  { name: "Dcto. Constancia", value: "Dcto. Constancia" },
  { name: "Dcto. Envio", value: "Dcto. Envio" },
  { name: "Deposito Yape", value: "Deposito Yape" },
  { name: "Deposito Plin", value: "Deposito Plin" },
];

export const CreateEditRewardStudentModal: React.FC<any> = ():
  | JSX.Element
  | any => {
  const {
    discountRewardStudentStore,
    getRewardStudent,
    selectedRewardStudentList,
    setSelectedRewardStudentList,
    openModal,
    setOpenModal,
    isEdit,
  } = useRewardStudentStore();

  const [data] = useState<RewardStudent>({
    idStudent: selectedRewardStudentList.id,
    concept: "",
    points: 0,
    conceptDetail: "",
    issueDate: new Date(),
    status: "1",
    type: "C",
  });
  const [selectedConcept, setSelectedConcept] = useState<{
    name: string;
    value: string;
    withDetail: boolean;
  } | null>(null);
  const [selectedConceptDetail, setSelectedConceptDetail] = useState(null);

  const filteredConcepts = useMemo(() => {
    return concepts.filter(
      ({ value }) => +value <= selectedRewardStudentList.points
    );
  }, [selectedRewardStudentList]);

  const onChangeConcept = useCallback(
    (newValue: any, setFieldValue: any) => {
      if (newValue) {
        const points = Number(newValue.value);
        setFieldValue("concept", newValue.name);
        setFieldValue("points", -points);
        setSelectedConcept(newValue);
      } else {
        setFieldValue("concept", "");
        setFieldValue("points", 0);
        setSelectedConcept(null);
      }
      setSelectedConceptDetail(null);
    },
    [setSelectedConcept]
  );

  const onChangeConceptDetail = useCallback(
    (newValue: any, setFieldValue: any) => {
      if (newValue) {
        setFieldValue("conceptDetail", newValue.name);
        setSelectedConceptDetail(newValue);
      } else {
        setFieldValue("conceptDetail", "");
        setSelectedConceptDetail(null);
      }
    },
    [setSelectedConceptDetail]
  );

  const validateForm = (values) => {
    let errors: any = {};

    if (!values.concept) {
      errors.concept = "Concepto es Requerido";
    }
    if (!values.conceptDetail && selectedConcept?.withDetail) {
      errors.conceptDetail = "Detalle es requerido";
    }
    return errors;
  };

  const onSubmit = async (values) => {
    const method = discountRewardStudentStore(values);
    const response = await method;
    if (response === true) {
      getRewardStudent(selectedRewardStudentList.dni);
      setSelectedRewardStudentList({
        ...selectedRewardStudentList,
        points:
          Number(selectedRewardStudentList.points) + Number(values.points),
      });
      setOpenModal(false);
    }
  };

  return (
    <>
      <Modal
        open={openModal}
        handleClose={() => setOpenModal(false)}
        disableEscapeKeyDown
        disableBackdropClick
        size="sm"
      >
        <ModalHeader
          text={isEdit ? "Editar Canje" : "Canjear"}
          className="positionElements"
          onCancel={() => setOpenModal(false)}
        ></ModalHeader>

        <Formik
          initialValues={data}
          enableReinitialize
          validate={(values) => validateForm(values)}
          onSubmit={onSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleSubmit,
            handleChange,
            setFieldValue,
          }) => {
            return (
              <>
                <ModalBody>
                  <form onSubmit={handleSubmit}>
                    <Grid container>
                      <Grid item container xs={12} spacing={2}>
                        <Grid item xs={12}>
                          <FormLabel>Concepto:</FormLabel>
                          <Autocomplete
                            id="concept"
                            value={selectedConcept}
                            options={filteredConcepts}
                            getOptionLabel={(option) => option.name || ""}
                            isOptionEqualToValue={(option, value) =>
                              option?.name === value?.name
                            }
                            fullWidth
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                error={errors.concept ? true : false}
                                helperText={
                                  errors.concept && touched.concept
                                    ? errors.concept
                                    : ""
                                }
                              />
                            )}
                            onChange={(e, newValue) => {
                              onChangeConcept(newValue, setFieldValue);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <FormLabel>Detalle:</FormLabel>
                          <Autocomplete
                            disabled={!selectedConcept?.withDetail}
                            id="conceptDetail"
                            value={selectedConceptDetail}
                            options={conceptDetails}
                            getOptionLabel={(option) => option.name || ""}
                            isOptionEqualToValue={(option, value) =>
                              option?.name === value?.name
                            }
                            fullWidth
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                error={errors.conceptDetail ? true : false}
                                helperText={
                                  errors.conceptDetail && touched.conceptDetail
                                    ? errors.conceptDetail
                                    : ""
                                }
                              />
                            )}
                            onChange={(e, newValue) => {
                              onChangeConceptDetail(newValue, setFieldValue);
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                </ModalBody>
                <ModalFooter
                  confirmText={isEdit ? "Actualizar" : "Canjear"}
                  onConfirm={handleSubmit}
                  cancelText={"Cancelar"}
                  onCancel={() => {
                    setOpenModal(false);
                  }}
                  className="modal-confirm-footer"
                />
              </>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
};
